import React, { Component } from "react";
// import { Button } from "react-bootstrap";
import { Form, Input, Button } from "antd";
import { withRouter } from "react-router";
import axios from "axios";


import './sass/Login.scss'

class Login extends Component {
  
  
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      result_status: "",
    };
  }

  componentDidMount() {
    if (localStorage.getItem("refresh_token")) {
      this.props.history.push(`/dashboard/clienti`);
    }
  }

  login = (event) => {
    event.preventDefault();

    axios
      .post(`${process.env.REACT_APP_SERVER_URL}/api/user/auth/signin`, {
        username: this.state.username,
        password: this.state.password,
      })
      .then((response) => {
        console.log(response);
        this.setState({ result_status: "success" });

        // this is the user object from the database
        let user = response.data;
        console.log(user);
        this.props.logIn(user);

        //redirect to dashboard
        this.props.history.push(`/dashboard/clienti`);

        console.log('do we get here')
      })
      .catch((error) => {

        console.log(error)
        this.setState({ result_status: "error" });
      });
  };

  render() {
    let result_h2_message;

    if (this.state.result_status === "error") {
      result_h2_message = (
        <p id="errorMessageLogin">Username o Password Errati!</p>
      );
    } else {
      result_h2_message = <div />;
    }

    return (
      <div className="containerLogin">
          <div id="leftDivLoginContainer">
            <div>
            <h4 id="titleLogin">Giorgiomare Gestione</h4>
            <img src="logo512.png" height="100px" width="100px" alt=""/>
            </div>
            <Form>
              <Form.Item hasFeedback validateStatus={this.state.result_status}>
                <Input
                  onChange={(e) => this.setState({ username: e.target.value })}
                  placeholder="Nome utente"
                />
              </Form.Item>

              <Form.Item hasFeedback validateStatus={this.state.result_status}>
                <Input
                  onChange={(e) => this.setState({ password: e.target.value })}
                  placeholder="Password"
                  type="password"
                />
              </Form.Item>

              {result_h2_message}

              <Button
                onClick={this.login.bind(this)}
                variant="primary"
                type="submit"
              >
                Login
              </Button>
            </Form>
        </div>
      </div>
    );
  }
}

export default Login = withRouter(Login);
